import { FunctionComponent, forwardRef, Ref, PropsWithoutRef } from 'react';
import styled from 'styled-components';
import { hideVisually } from 'polished';

import { ForwardProps } from '../../types';

interface VisuallyHiddenTextProps {
  children: string;
  ref?: Ref<HTMLSpanElement>;
}

export const StyledVisuallyHiddenText = styled.span`
  ${hideVisually}
`;

const VisuallyHiddenText: FunctionComponent<VisuallyHiddenTextProps & ForwardProps> = forwardRef(
  (props: PropsWithoutRef<VisuallyHiddenTextProps>, ref: VisuallyHiddenTextProps['ref']) => (
    <StyledVisuallyHiddenText {...props} ref={ref} />
  )
);

export default VisuallyHiddenText;
